/**
 * Generates a fixed height and width pillbox image.
 *
 * @param url string - The original url of the image.
 * @param width number - The width of the final image.
 */
export const getPilbox = (url, width) => {
    const props = `filter=antialias&opt=1&pos=top-left&prog=1&q=keep&url=${url}&w=${width}`;
    return `https://pilbox.themuse.com/image.png?${props}`;
};
/**
 * Convert a word to proper Case.
 */
export const titleWordCase = (txt) => `${txt.charAt(0).toUpperCase()}${txt.slice(1).toLowerCase()}`;
/**
 * Regex for non-alphanumerics and spaces.
 */
const regex = /([~!@#$%^&*\]){}_+\-(\s])/ig;
/**
 * Convert a sentence to proper Case.
 */
export const titleCase = (txt) => txt.split(regex).map(titleWordCase).join("");
/**
 * Convert number to string and add a comma for thousands and millions.
 */
export const formatNumberComma = (value) => {
    const numberVal = parseInt(value, 10);
    return Number.isNaN(numberVal) ? value : new Intl.NumberFormat("en-US").format(numberVal);
};
/**
 * Remove all contiguous whiteSpace,
 * * ' ' spaces.
 * * \n linefeed (LF or 0x0A (10) in ASCII).
 * * \r carriage return (CR or 0x0D (13) in ASCII).
 * * \t horizontal tab (HT or 0x09 (9) in ASCII).
 * * \v vertical tab (VT or 0x0B (11) in ASCII).
 * * \f form feed (FF or 0x0C (12) in ASCII).
 */
export const collapseWhiteSpace = (content) => content
    .trim()
    .replace(/[ \n\r\t\v\f]+/gm, " "); // replace non-printing characters
/**
 * Convert a string to a slug.
 * * Decode URL encoded strings.
 * * Remove all white space with collapseWhiteSpace.
 * * Convert all diacritic to generics.
 * * Replace not alpha-numerics with dashes.
 * * Collapse all dashes to one dash.
 */
export const slugify = (text) => decodeURIComponent(collapseWhiteSpace(text))
    .toLowerCase()
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .replace(/[^a-z0-9]/gmi, "-")
    .replace(/-+/g, "-");
/**
 * Truncate a string to a given length with a trailing ellipsis.
 */
export const truncateStringWithEllipsis = (targetString, truncateLength) => targetString.length > truncateLength
    ? targetString.slice(0, truncateLength).concat("...") : targetString;
/**
 * Returns true for "true", "True", "TRUE" and "1".
 * @param string string
 * @returns boolean
 */
export const isTruthy = (string) => /^(true|1)$/.test(string.toLowerCase());
//# sourceMappingURL=string.js.map